module.exports = __webpack_public_path__ + "img/stepup.189b5a5d.svg";